import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTestBuyLocation = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 20,
	fill: "none",
	viewBox: "0 0 16 20",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#111",
			d: "M8 9.2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#111",
			fillRule: "evenodd",
			d: "M8 19.4c3.7-2.5 7.4-6.6 7.4-11.3C15.4 4 12 .6 8 .6S.6 4.1.6 8.1c0 4.7 3.7 8.8 7.4 11.3ZM2.6 8c0-3 2.5-5.5 5.4-5.5 2.9 0 5.4 2.6 5.4 5.5 0 3.6-2.7 6.7-5.4 8.8-2.7-2-5.4-5.2-5.4-8.8Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#111",
			d: "M10 7.2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
		})
	]
});
export default SvgTestBuyLocation;
